import _ from 'lodash';
import React, { Component } from 'react';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import NetworkEmptyState from '../../commons/networkemptystate';
import Loader from '../../commons/loader';
import Moment from 'moment';
import { ProgressButton } from '../../commons/ProgressButton';
import Services from './Services';
import { Localization } from 'react-widgets';
import { DatetimePicker } from '../../commons/controls'
import momentLocalizer from "react-widgets-moment";
import Select from 'react-select/async';
// import PartnerHozzajarulasForm from './PartnerHozzajarulasForm';
import NumberFormatter from '../../commons/NumberFormatter';
import SlaveAvInput from '../../commons/SlaveAvInput';
import RFForm from '../../components/Form/RFForm';
import RFField from '../../components/Form/RFField';
import TimeFormatter from '../../commons/TimeFormatter';
import FileSaver from 'file-saver';
// momentLocalizer(Moment);
Moment.locale('hu');
const localizer = new momentLocalizer(Moment);
const STYLE_CHECKBOX = {margin: 0, marginTop: 5, position: 'absolute', top: '50%', msTransform: 'translateY(-50%)', transform: 'translateY(-50%)'}

const CONSTANTS = {
  fizetesiModAzonositok: ['KP', 'UTA', 'PPOS'],
};

/**
 * Osztály terembérlés űrlap létrehozására.
 * @extends Component
 */
class TeremberlesUrlap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formType: 'INSERT',
      modositoStatus: false,
      saveButtonLoading: false,
      savePartnerLoading: false,
      deleteButtonLoading: false,
      modalFizetes: false,
      modalDelete: false,
      partnerModal: false,
      // MODAL FORM VALUES
      teremberlesObj: {},

      helyszinek: [],
      helyszinCegadat: {},
      termek: [],
      termekCurrent: [],
      kiosztasok: [],
      kiosztasokCurrent: [],
      helyszinValue: '',
      teremValue: '',
      kiosztasValue: '',
      allapotValue: '',
      programnevValue: '',
      showTulajdonosGdprForm: false,
      partnerResponse: null,
      partnercsoportok: [],
      orszaghivok: [],
      originalPartner: {}
    };
  }

  componentDidMount() {
    this.selected = false;
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if ((this.props.modalView !== prevProps.modalView || this.props.modalForm !== prevProps.modalForm || this.props.modalDelete !== prevProps.modalDelete)
      && (this.props.modalView || this.props.modalForm || this.props.modalDelete) ) {
      switch (this.props.formType) {
        case 'VIEW':
          this.getTeremberles(this.props.id);
          break;

        case 'INSERT':
          this.initTeremberles();
          break;

        case 'MODIFY':
          this.initTeremberles(this.props.id);
          break;

        default:
          break;
      }
    }
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  dateToTimezone = (date) => {
    if (!date || date === '') return null;
    return TimeFormatter.format(date, "YYYY-MM-DDTHH:mm:00.000ZZ");
  }

  togglePartnerModal = () => {
    if (!this.state.helyszinValue)
      this.props.globals.addError("Partner rögzítése előtt helyszín választása kötelező!");
    else {
      if (!this.state.partnerModal)
        this.initPartnerRogzites();
      this.setState((prevState) => ({
        partnerModal: !prevState.partnerModal,
        elfogadas: false,
      }));
    }
  }

  toggleShowTulajdonosGdprForm = (show) => {
    this.setState({ showTulajdonosGdprForm: show});
  }

  setPartnerResponse = (response) => {
    this.setState({ partnerResponse: response});
  }

  setPartnerAdatok = (originalPartner) => {
    if (originalPartner) {
      this.setState({
        partnerValue: originalPartner
      });
    } else {
      let nev;
      if ('CEG' === this.state.insertTipusValue)
      nev = this.state.insertCegnevValue;
      else {
        nev = this.state.insertTitulusValue ? this.state.insertTitulusValue : '';
        nev += ' ' + (this.state.insertVezeteknevValue ? this.state.insertVezeteknevValue: '');
        nev += ' ' + (this.state.insertKeresztnevValue ? this.state.insertKeresztnevValue: '');
        nev = nev.trim();
      }

      let tel = '';
      if (this.state.insertTelefonValue) {
        if (this.state.insertOrszaghivoValue)
          this.state.orszaghivok.forEach((o) => {
            if (this.state.insertOrszaghivoValue === o.name)
              tel += '+' + o.num;
          });
        tel += ' ' + this.state.insertTelefonValue;
        tel = tel.trim();
      }

      let pcs = '';
      this.state.partnercsoportok.forEach((p) => {
        if (this.state.insertPartnercsoportValue == p.id)
          pcs = p.nev;
      })

      this.setState({
        partnernevValue: nev,
        partnercsoportValue: pcs,
        partneremailValue: this.state.insertEmailValue,
        partnertelefonValue: tel
      });
    }
  }

  initPartnerRogzites = () => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.initPartnerInsert((err, res) => {
      if (!err) {
        let tipusOptions = res[0].tipus.map(e => <option key={e.name} value={e.name}>{e.caption}</option>);
        let partnercsoportOptions = res[0].partnercsoport.map(e => <option key={e.id} value={e.id}>{e.nev}</option>);
        let telefontipusOptions = res[0].telefontipus.map(e => <option key={e.name} value={e.name}>{e.caption}</option>);
        let orszaghivoOptions = res[0].orszaghivo.map(e => <option key={e.name} value={e.name}>{e.caption}{e.num ? (' (+' + e.num + ')') :''}</option>);

        this.setState({
          formStatus: 'DATA',
          // formType: 'MOD',
          tipusOptions: tipusOptions,
          partnercsoportOptions: partnercsoportOptions,
          partnercsoportok: res[0].partnercsoport,
          insertPartnercsoportValue: res[0].alapertpcsop,
          telefontipusOptions: telefontipusOptions,
          orszaghivoOptions: orszaghivoOptions,
          orszaghivok: res[0].orszaghivo,

          insertTipusValue: '',
          insertCegnevValue: '',
          insertTitulusValue: '',
          insertVezeteknevValue: '',
          insertKeresztnevValue: '',
          insertTelefontipusValue: '',
          insertOrszaghivoValue: 'HU',
          insertTelefonValue: '',
          insertEmailValue: ''
        });
      } else {
        this.setState({
          formStatus: 'NETW'
         });
      }
    });
  }

  initTeremberles = (id) => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.initTeremberles(id, CONSTANTS.fizetesiModAzonositok, (err, res) => {
      if (!err) {
        let helyszinOptions = [];
        let teremOptions = [];
        let teremOptionsInit = [];
        let kiosztasOptions = [];
        let kiosztasOptionsInit = [];

        for (const [key, value] of Object.entries(res[0].helyszin)) {
          let helyszinOption = {};
          helyszinOption.key = key.substring(key.lastIndexOf('|') + 1);
          helyszinOption.value = key.substring(0, key.lastIndexOf('|'));
          helyszinOptions.push(helyszinOption);
          for (const [key2, value2] of Object.entries(value)) {
            let teremOption = {};
            teremOption.key = key2.substring(key2.lastIndexOf('|') + 1);
            teremOption.value = key2.substring(0, key2.lastIndexOf('|'));
            teremOption.helyszinid = helyszinOption.key;
            teremOptions.push(teremOption);

            if (!res[0].helyszinid || (res[0].helyszinid && res[0].helyszinid === helyszinOption.key)) {
              teremOptionsInit.push(teremOption);
            }

            for(let k of value2){
              let kiosztasOption = {};
              kiosztasOption.key = k.substring(k.lastIndexOf('|') + 1);
              kiosztasOption.value = k.substring(0, k.lastIndexOf('|'));
              kiosztasOption.teremid = teremOption.key;
              kiosztasOptions.push(kiosztasOption);

              if (res[0].teremberles && res[0].teremberles.teremid &&  res[0].teremberles.teremid === parseInt(kiosztasOption.teremid, 10))
                kiosztasOptionsInit.push(kiosztasOption);
            }
          }
        }

        this.setState({ helyszinCegadat: res[0].helyszincegadat, jogalapid: res[0].jogalap?.id, jogalapnev: res[0].jogalap?.nev });

        let fizModOptions = res[0].fizmod.map(e => <option key={e.variansid ? e.variansid : e.id} value={e.variansid ? e.variansid : e.id}>{e.variansnev ? e.variansnev : e.nev}</option>);
        let penznemOptions = res[0].penznem.map(e => (<option key={e.id} value={e.id}>{e.nev + ' (' + e.azonosito + ')'}</option>));

        let partner = {};
        if (res[0].teremberles && res[0].teremberles.partnertortenetid) {
          partner.id = res[0].teremberles.partnertortenetid;
        }

        let helyszinValue;
        if (!id && helyszinOptions.length === 1) {
          helyszinValue = helyszinOptions[0].key;
        } else {
          helyszinValue = res[0].helyszinid ? res[0].helyszinid : '';
        }

        let cegadat = res[0].helyszinid && res[0].helyszincegadat && res[0].helyszincegadat[res[0].helyszinid];

        this.setState({
          formStatus: 'DATA',
          // formType: 'MOD',
          helyszinek: helyszinOptions,
          helyszinValue: helyszinValue,

          termek: teremOptions,
          teremValue: res[0].teremberles && res[0].teremberles.teremid ? res[0].teremberles.teremid : '',
          termekCurrent: teremOptionsInit,

          kiosztasok: kiosztasOptions,
          kiosztasValue: res[0].teremberles && res[0].teremberles.teremkiosztasid ? res[0].teremberles.teremkiosztasid : '',
          kiosztasokCurrent: kiosztasOptionsInit,

          allapotValue: res[0].teremberles && res[0].teremberles.allapot ? res[0].teremberles.allapot : 'Rögzítés',
          kezdeteidopontValue: res[0].teremberles && res[0].teremberles.kezdeteidopont ? res[0].teremberles.kezdeteidopont : null,
          vegeidopontValue: res[0].teremberles && res[0].teremberles.vegeidopont ? res[0].teremberles.vegeidopont : null,
          programnevValue: res[0].teremberles && res[0].teremberles.nev ? res[0].teremberles.nev : '',
          letszamValue: res[0].teremberles && res[0].teremberles.letszam ? res[0].teremberles.letszam : '',
          leirasValue: res[0].teremberles && res[0].teremberles.leiras ? res[0].teremberles.leiras : '',

          partnerValue: partner,
          originalPartner: partner,
          partnernevValue: res[0].teremberles && res[0].teremberles.partner && res[0].teremberles.partner.nev ? res[0].teremberles.partner.nev : '',
          partnercsoportValue: res[0].teremberles && res[0].teremberles.partner && res[0].teremberles.partner.partnercsoport ? res[0].teremberles.partner.partnercsoport : '',
          partneremailValue: res[0].teremberles && res[0].teremberles.partner && res[0].teremberles.partner.email ? res[0].teremberles.partner.email : '',
          partnertelefonValue: res[0].teremberles && res[0].teremberles.partner && res[0].teremberles.partner.telefon ? res[0].teremberles.partner.telefon : '',

          dijValue: res[0].teremberles && (res[0].teremberles.dij || res[0].teremberles.dij === 0) ? res[0].teremberles.dij : '',
          penznemValue: res[0].teremberles ? res[0].teremberles.penznemid : res[0].alappenznemid,
          fizmodValue: res[0].teremberles && res[0].teremberles.fizetesimodid ? res[0].teremberles.fizetesimodid : '',
          fizetesidopontValue: res[0].teremberles && res[0].teremberles.fizetesidopont ? res[0].teremberles.fizetesidopont : null,
          bizonylatszamValue: res[0].teremberles && res[0].teremberles.bizonylatszam ? res[0].teremberles.bizonylatszam : '',

          fizModOptions: fizModOptions,
          penznemOptions: penznemOptions,

          cegadatnev: cegadat && cegadat.nev,
          cegadatid: cegadat && cegadat.id,
        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  getTeremberles = (id) => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.getTeremberles(id, (err, res) => {
      if (!err) {
        this.setState({
          formStatus: 'DATA',
          // formType: 'MOD',
          teremberlesObj: res[0].teremberles,
        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleHelyszinChange = (event, value) => {
    let teremOptions = [];
    for(let terem of this.state.termek) 
      if (terem.helyszinid === value)
        teremOptions.push(terem);

    let cegadat = this.state.helyszinCegadat && this.state.helyszinCegadat[value];

    this.setState( { helyszinValue: value, teremValue: '', termekCurrent: teremOptions, kiosztasValue: '', cegadatnev: cegadat && cegadat.nev, cegadatid: cegadat && cegadat.id });
  }

  handleTeremChange = (event, value) => {
    let kiosztasOptions = [];
    for(let kiosztas of this.state.kiosztasok) 
      if (kiosztas.teremid === value)
        kiosztasOptions.push(kiosztas);

    this.setState( { teremValue: value, kiosztasokCurrent: kiosztasOptions, kiosztasValue: ''});
  }

  handleKiosztasChange = (event, value) => {
    this.setState( { kiosztasValue: value});
  }

  handleIdopontChange = (name, value) => {
    this.setState({
      [name]: value ? this.dateToTimezone(value) : null
    });
  }

  handleDateChange = (e,v,type) => {
    if(this.selected) {
      this.selected = false;
      
      switch (type) {
        case 'FORMPROGRAMKEZDETE':
          this.setState({ kezdeteidopontValue: (Moment(e).startOf('day')) });
          break;
        case 'FORMPROGRAMVEGE':
          this.setState({ vegeidopontValue: (Moment(e).startOf('day')) });
          break;
        case 'FORMFIZETESIDO':
          this.setState({ fizetesidopontValue: Moment(e) });
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'FORMPROGRAMKEZDETE':
          this.setState({ kezdeteidopontValue: (v === '' ? null : e) });
          break;
        case 'FORMPROGRAMVEGE':
          this.setState({ vegeidopontValue: (v === '' ? null : e) });
          break;
        case 'FORMFIZETESIDO':
          this.setState({ fizetesidopontValue: e });
          break;
        default:
          break;
      }
    }
  }

  handleChangePartner = (value) => {
    this.setState({
      partnernevValue : value && value.nev ? value.nev : '',
      partnercsoportValue: value && value.partnercsoport ? value.partnercsoport : '',
      partneremailValue: value && value.email ? value.email : '',
      partnertelefonValue: value && value.telefon ? value.telefon : '',
      partnerValue: value,
      originalPartner: value
    });
  }

  loadPartnerChange = (input, callback) => {
    if (input.length !== 0) {
      Services.searchPartner('TEREMBERLES_FORM', input, (err, res) => {
        if (!err) {
          let newArray = [];
          res[0].forEach((item) => {
            item.nevoption = item.email ? (item.nev + ' (' + item.email + ') ') : item.nev;
            newArray.push(item);
          });
          callback(newArray);
        }
      });
    }
  }

  deleteTeremberles = (id) => {
    this.setState({ deleteButtonLoading: true });
    Services.deleteTeremberles(id, (err) => {
      if (!err) {
        this.setState({ deleteButtonLoading: false });
        this.props.globals.addSuccess('Terembérlés sikeresen törölve!');
        this.props.toggleDeleteModal();
        this.props.listTeremberles();
      } else {
        this.setState({ deleteButtonLoading: false });
      }
    })
  }

  renderFormTitle = () => {
    switch (this.props.formType) {
      case 'INSERT':
        return 'Új terembérlés létrehozása';
      case 'MODIFY':
        return 'Terembérlés módosítása';
      default:
        return 'Terembérlés';
    }
  }

  renderHelyszinOptions = () => {
    return this.state.helyszinek.map(h => { return <option value={h.key} key={h.key}>{h.value}</option> })
  }

  renderTeremOptions = () => {
    return this.state.termekCurrent.map(h => { return <option value={h.key} key={h.key}>{h.value}</option> })
  }

  renderKiosztasOptions = () => {
    return this.state.kiosztasokCurrent.map(h => { return <option value={h.key} key={h.key}>{h.value}</option> })
  }

  renderAlapadatok = () => {
    return (
      <React.Fragment>
        <div className="col-md-4">
            <RFField
              label={'Helyszín:'}
              type='select'
              name="helyszinValue"
              id="helyszin"
              value={this.state.helyszinValue}
              onChange={this.handleHelyszinChange}
              defaultSelect={<option key="null" value="">Válassz helyszínt...</option>}
              selectOptions={this.renderHelyszinOptions()}
              required
            />
        </div>
        <div className="col-md-4">
            <RFField
              label={'Terem:'}
              type="select"
              name="teremValue"
              id="terem"
              value={this.state.teremValue}
              onChange={this.handleTeremChange}
              disabled={this.state.helyszinValue === ''}
              defaultSelect={<option key="null" value="">Válassz termet...</option>}
              selectOptions={this.renderTeremOptions()}
              required
              />
        </div>
        <div className="col-md-4">
          {this.state.kiosztasokCurrent.length !== 0 && (
            <RFField
              label={'Teremkiosztás:'}
              type="select"
              name="teremKiosztasValue"
              id="teremKiosztas"
              value={this.state.kiosztasValue}
              onChange={this.handleKiosztasChange}
              disabled={this.state.teremValue === '' || this.state.kiosztasokCurrent.length === 0}
              defaultSelect={<option key="null" value={''}>Válassz teremkiosztást...</option>}
              selectOptions={this.renderKiosztasOptions()}
            />
          )}
        </div>
        <div className="col-md-4">
            <RFField
              label={'Állapot:'}
              type="text"
              name="allapotValue"
              id="allapot"
              value={this.state.allapotValue && this.state.allapotValue}
              disabled
            />
        </div>
        <div className="col-md-4">
             <DatetimePicker 
                label={'Program kezdete: *'}
                containerClassName="organw-date-time"
                // format="YYYY-MM-DD HH:mm"
                messages={{ dateButton: 'dátum', timeButton: 'idő' }}
                // onChange={(v) => this.handleIdopontChange('kezdeteidopontValue', v)}
                onChange={(e,v) => {this.handleDateChange(e,v,'FORMPROGRAMKEZDETE')}} 
                onSelect={(e,v) => { this.selected = true }}
                ref={ kezdeteidopont => this.kezdeteidopont = kezdeteidopont }
                value={this.state.kezdeteidopontValue && new Date(this.state.kezdeteidopontValue)}
                name="kezdeteidopontValue"
                id="kezdeteidopont"
                timePrecision="seconds"
                />
        </div>
        <div className="col-md-4">
            <DatetimePicker
                label={'Program vége: *'}
                containerClassName="organw-date-time"
                // format="YYYY-MM-DD HH:mm"
                messages={{ dateButton: 'dátum', timeButton: 'idő' }}
                //onChange={(v) => this.handleIdopontChange('vegeidopontValue', v)}
                onChange={(e,v) => {this.handleDateChange(e,v,'FORMPROGRAMVEGE')}} 
                onSelect={(e,v) => { this.selected = true }}
                ref={ vegeidopont => this.vegeidopont = vegeidopont }
                value={this.state.vegeidopontValue && new Date(this.state.vegeidopontValue)}
                name="vegeidopontValue"
                id="vegeidopont"
                timePrecision="seconds"
              />
        </div>
        <div className="col-md-9">
            <RFField
              label={'Program megnevezése: *'}
              type="text"
              name="programnevValue"
              id="programnev"
              value={this.state.programnevValue}
              onChange={this.handleInputChange}
            />
        </div>
        <div className="col-md-3">
          <SlaveAvInput
            id="letszamValue"
            name="letszamValue"
            label="Létszám:"
            min="1"
            value={this.state.letszamValue}
            onChange={this.handleInputChange}
            szuroTipus={NumberFormatter.OSSZEG}
            inputGroupAddon="fő"
            emptyStringOnZero
          />
        </div>
        <div className="col-md-12">
            <RFField
              label={'Leírás:'}
              type="textarea"
              name="leirasValue"
              id="leiras"
              value={this.state.leirasValue}
              onChange={this.handleInputChange}
            />
        </div>
      </React.Fragment>
    );
  }

  renderBerloAdatok = () => {
    return (
      <React.Fragment>
        <div className="col-md-12">
          <h5><i>Bérlő: </i></h5>
          &nbsp;&nbsp;
          <Button color="primary" onClick={this.togglePartnerModal}>Partner rögzítése</Button>
        </div>
        <div className="col-md-12" />
        <br />
        <div className="col-md-6">
          <div>
            <Label>Partner kiválasztása:</Label>
            <Select
              styles={{
                control: base => ({
                  ...base,
                  '&:focus': { borderColor: 'red' }, // border style on hover
                  border: '1px solid lightgray', // default border color
                  boxShadow: 'none', // no box-shadow
                  borderRadius: '0'
                }),
              }}
              name="partnerValue"
              id="partner"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              searchPromptText="Kezdj el gépelni a kereséshez..."
              loadingMessage={() => 'Keresés...'}
              onChange={v => this.handleChangePartner(v)}
              isClearable
              ignoreAccents={false}
              loadOptions={_.debounce(this.loadPartnerChange, 1000)}
              isLoading={false}
              getOptionLabel={option => option.nevoption}
              getOptionValue={option => option.id}
              value={this.state.partnerValue}
              cache={false}
              autoload={false}
            />
          </div>
        </div>
        <div className="col-md-6">
            <RFField
              label={'Név: *'}
              type="text"
              name="partnernevValue"
              id="nev"
              value={this.state.partnernevValue}
              disabled
            />
        </div>
        <div className="col-md-4">
            <RFField
              label={'Partnercsoport: *'}
              type="text"
              name="partnercsoportValue"
              id="partnercsoport"
              value={this.state.partnercsoportValue}
              disabled
            />
        </div>
        <div className="col-md-4">
            <RFField
              label={'Email:'}
              type="text"
              name="partneremailValue"
              id="email"
              value={this.state.partneremailValue}
              disabled
            />
        </div>
        <div className="col-md-4">
            <RFField
              label={'Telefonszám:'}
              type="text"
              name="partnerTelefonValue"
              id="telefon"
              value={this.state.partnertelefonValue}
              disabled
            />
        </div>
      </React.Fragment>
    );
  }

  pdfSend = () => {
    const { insertTipusValue, insertTitulusValue, insertVezeteknevValue, insertKeresztnevValue, insertCegnevValue } = this.state;
    let partnerNev;
    if ('CEG' === insertTipusValue)
      partnerNev = insertCegnevValue;
    else
      partnerNev = (this.emptyOrNull(insertTitulusValue) ? (insertTitulusValue + " ") : "") + insertVezeteknevValue + " " + insertKeresztnevValue;
    Services.pdfGDPRGenerate(null, partnerNev, this.state.jogalapid, this.state.cegadatid, TimeFormatter.formatDate(new Date()) , null, (err, res) => {
      if (!err) {
        FileSaver.saveAs(new Blob([res[0]], { type: 'application/pdf' }), 'hozzajarulas');
      }
    });
  }

  renderPartnerRogzites = () => {
    return (
      <React.Fragment>
        <div className="col-md-12">
          <h5><i>Alapadatok:</i></h5>
        </div>
        <div className="col-md-6">
          <RFField
            type="select"
            name="insertTipusValue"
            id="tipus"
            label="Típus: *"
            value={this.state.insertTipusValue}
            onChange={this.handleInputChange}
            errorMessage="Kötelező mező!"
            required
            defaultSelect={<option key="null" value={''}>Válassz partnertípust...</option>}
            selectOptions={this.state.tipusOptions}
          />
        </div>
        <div className="col-md-6">
          <RFField
            type="select"
            name="insertPartnercsoportValue"
            id="partnercsoport"
            label="Partnercsoport:"
            value={this.state.insertPartnercsoportValue}
            onChange={this.handleInputChange}
            errorMessage="Kötelező mező!"
            defaultSelect={<option key="null" value={null}>Válassz opciót...</option>}
            selectOptions={this.state.partnercsoportOptions}
          />
        </div>
        {this.state.insertTipusValue ? ('CEG' === this.state.insertTipusValue ? (
          <div className="col-md-12">
              <RFField
                label={'Cégnév:'}
                type="text"
                name="insertCegnevValue"
                id="cegnev"
                value={this.state.insertCegnevValue}
                onChange={this.handleInputChange}
              />
          </div>) :
          (
            <React.Fragment>
              <div className="col-md-2">
                  <RFField
                    label={'Titulus:'}
                    type="text"
                    name="insertTitulusValue"
                    id="titulus"
                    value={this.state.insertTitulusValue}
                    onChange={this.handleInputChange}
                  />
              </div>
              <div className="col-md-5">
                  <RFField
                    label={'Vezetéknév:'}
                    type="text"
                    name="insertVezeteknevValue"
                    id="vezeteknev"
                    value={this.state.insertVezeteknevValue}
                    onChange={this.handleInputChange}
                  />
              </div>
              <div className="col-md-5">
                <RFField
                  label={'Keresztnév:'}
                  type="text"
                  name="insertKeresztnevValue"
                  id="keresztnev"
                  value={this.state.insertKeresztnevValue}
                  onChange={this.handleInputChange}
                />
            </div>
          </React.Fragment>
          )):(<React.Fragment><div className="col-md-12" style={{ height: '78.25px' }}></div></React.Fragment>)}
        <div className="col-md-12">
          <h5><i>Elérhetőségek:</i></h5>
        </div>
        <div className="col-md-2">
          <RFField
            type="select"
            name="insertTelefontipusValue"
            id="telefontipus"
            label="Telefon típus:"
            value={this.state.insertTelefontipusValue}
            onChange={this.handleInputChange}
            errorMessage="Kötelező mező!"
            defaultSelect={<option key="null" value={''}>Válassz opciót...</option>}
            selectOptions={this.state.telefontipusOptions}
          />
        </div>
        <div className="col-md-3">
          <RFField
            type="select"
            name="insertOrszaghivoValue"
            id="orszaghivo"
            label="Országhívó:"
            value={this.state.insertOrszaghivoValue}
            onChange={this.handleInputChange}
            errorMessage="Kötelező mező!"
            defaultSelect={<option key="null" value={''}>Válassz opciót...</option>}
            selectOptions={this.state.orszaghivoOptions}
          />
        </div>
        <div className="col-md-3">
            <RFField
              label={'Telefonszám:'}
              type="text"
              name="insertTelefonValue"
              id="telefon"
              value={this.state.insertTelefonValue}
              onChange={this.handleInputChange}
            />
        </div>
        <div className="col-md-4">
            <RFField
              label={'Email:'}
              type="text"
              name="insertEmailValue"
              id="email"
              value={this.state.insertEmailValue}
              onChange={this.handleInputChange}
            />
        </div>
        {this.state.insertTipusValue == 'MAGANSZEMELY' &&
          <>
            <div className="col-md-3">
              <RFField
                label={'Jogalap:'}
                disabled
                name={"jogalap"}
                value={this.state.jogalapnev}
              />
            </div>
            <div className="col-md-3">
                <RFField
                  label={'Kiállító:'}
                  disabled
                  name={"cegadat"}
                  id={"cegadat"}
                  value={this.state.cegadatnev}
                />
            </div>
            <div className="col-md-2">
              <DatetimePicker
                label={'Kezdete:'}
                id={"kezdete"}
                name={"kezdete"}
                containerClassName="organw-date-time"
                time={false}
                messages={{ dateButton: "dátum", timeButton: "idő" }}
                value={new Date()}
                disabled
              />
            </div>
            <div className="col-md-1">
              <Button color="danger" style={{ marginTop: '29px' }} type="button" onClick={this.pdfSend}>
                PDF
              </Button>
              {' '}
            </div>
            <div className="col-md-3">
              <div check style={STYLE_CHECKBOX}>
                <RFField
                  label={'Hozzájárul'}
                  type="checkbox"
                  id={"elfogadas"}
                  name={"elfogadas"}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </>
        }
      </React.Fragment>
    );
  }

  renderFizetesiAdatok = () => {
    return (
      <React.Fragment>
        <div className="col-md-12"><h5><i>Fizetési adatok:</i></h5></div>
        <div className="col-md-3">
          <SlaveAvInput
            id="dijValue"
            name="dijValue"
            label="Bérleti díj (bruttó):"
            min="0"
            value={this.state.dijValue}
            onChange={this.handleInputChange}
            szuroTipus={NumberFormatter.OSSZEG}
            disabled={!this.props.hasFizKarbRole}
            emptyStringOnZero={typeof this.state.dijValue != 'number'}
            required
          />
        </div>
        <div className="col-md-3">
            <RFField
              label={'Pénznem:'}
              type="select"
              name="penznemValue"
              id="pénznem"
              value={this.state.penznemValue}
              onChange={this.handleInputChange}
              disabled={!this.props.hasFizKarbRole}
              defaultSelect={<option key="fizmod" value="">Válassz pénznemet!</option>}
              selectOptions={this.state.penznemOptions}
              required
            />
        </div>
        <div className="col-md-3">
            <RFField
              label={'Fizetés módja:'}
              type="select"
              name="fizmodValue"
              id="fizmod"
              value={this.state.fizmodValue}
              onChange={this.handleInputChange}
              disabled={!this.props.hasFizKarbRole}
              defaultSelect={<option key="fizmod" value="">Válassz fizetési módot!</option>}
              selectOptions={this.state.fizModOptions}
            />
        </div>
        <div className="col-md-3">
          <div>
             <DatetimePicker
                label={'Fizetés időpontja:'}
                containerClassName="organw-date-time"
                // format="YYYY-MM-DD HH:mm"
                messages={{ dateButton: 'dátum', timeButton: 'idő' }}
                //onChange={(e, v) => this.handleIdopontChange('fizetesidopontValue', v)}
                onChange={(e,v) => {this.handleDateChange(e,v,'FORMFIZETESIDO')}} 
                onSelect={(e,v) => { this.selected = true }}
                ref={ fizetesidopont => this.fizetesidopont = fizetesidopont }
                value={this.state.fizetesidopontValue && new Date(this.state.fizetesidopontValue)}
                name="fizetesidopontValue"
                id="fizetesidopont"
                timePrecision="seconds"
              />

              <br />
          </div>
        </div>
        <div className="col-md-12">
            <RFField
              label={'Bizonylatszám:'}
              type="text"
              name="bizonylatszamValue"
              id="bizonylatszam"
              value={this.state.bizonylatszamValue}
              onChange={this.handleInputChange}
              disabled={!this.props.hasFizKarbRole}
            />
        </div>
      </React.Fragment>
    );
  }

  renderView = () => {
    return(
      <div>
        <h6>Terembérlés adatok:</h6>
        <b>Helyszín neve: </b>{this.state.teremberlesObj.helyszin}<br />
        <b>Terem neve: </b>{this.state.teremberlesObj.terem}<br />
        <b>Állapot: </b>{this.state.teremberlesObj.allapot && this.state.teremberlesObj.allapot}<br />
        <b>Program kezdete: </b>{TimeFormatter.formatDateTimeWithoutSeconds(this.state.teremberlesObj.kezdeteidopont)}<br />
        <b>Program vége: </b>{TimeFormatter.formatDateTimeWithoutSeconds(this.state.teremberlesObj.vegeidopont)}<br />
        <b>Program megnevezése: </b>{this.state.teremberlesObj.nev}<br />
        <b>Létszám: </b>{this.state.teremberlesObj.letszam && NumberFormatter.addSpacesToString(this.state.teremberlesObj.letszam, NumberFormatter.OSSZEG) + ' fő'}<br />
        <b>Leírás: </b>{this.state.teremberlesObj.leiras}<br />
        <br />
        <h6>Bérlő adatok:</h6>
        <b>Név: </b>{this.state.teremberlesObj.partner && this.state.teremberlesObj.partner.nev}<br />
        <b>Partnercsoport: </b>{this.state.teremberlesObj.partner && this.state.teremberlesObj.partner.partnercsoport}<br />
        <b>Email: </b>{this.state.teremberlesObj.partner && this.state.teremberlesObj.partner.email}<br />
        <b>Telefon: </b>{this.state.teremberlesObj.partner && this.state.teremberlesObj.partner.telefon}<br />
        <br />
        <h6>Fizetés adatok:</h6>
        <b>Bérleti díj (bruttó): </b>{this.state.teremberlesObj.dij || 0 === this.state.teremberlesObj.dij ? (NumberFormatter.addSpacesToString(this.state.teremberlesObj.dij, NumberFormatter.OSSZEG) + (this.state.teremberlesObj.penznem ? ' ' + this.state.teremberlesObj.penznem : '')): '' }<br />
        <b>Fizetés módja: </b>{this.state.teremberlesObj.fizmod}<br />
        <b>Fizetés időpontja: </b>{this.state.teremberlesObj.fizetesidopont && TimeFormatter.formatDateTimeWithoutSeconds(this.state.teremberlesObj.fizetesidopont)}<br />
        <b>Fizetést végző felhasználó: </b>{this.state.teremberlesObj.fizuser}<br />
        <b>Bizonylatszám: </b>{this.state.teremberlesObj.bizonylatszam}<br />
        <br />
        <h6>Egyéb adatok:</h6>
        <b>Rögzítés időpontja: </b>{TimeFormatter.formatDateTimeWithoutSeconds(this.state.teremberlesObj.rogzitesidopont)}<br />
        <b>Rögzítést végző felhasználó: </b>{this.state.teremberlesObj.rogzuser}<br />
        <b>Utolsó módosítás időpontja: </b>{this.state.teremberlesObj.modositasidopont && TimeFormatter.formatDateTimeWithoutSeconds(this.state.teremberlesObj.modositasidopont)}<br />
        <b>Utolsó módosítást végző felhasználó: </b>{this.state.teremberlesObj.moduser}<br />
      </div>
    );
  }

  // EREDETI megvalósítás ideiglenesen kivéve (nem kell egyelőre a gdpr hozzájárulás form) - 20201211 - MG
  // VISSZAÁLLÍTÁSKOR AZ 1173. sor körüli formot is vissza kell tenni!

  // insertPartner = () => {
  //   this.setState({ savePartnerLoading: true });

  //   let isCeg = 'CEG' === this.state.insertTipusValue;
  //   let submitObj = {};
  //   submitObj.tipus = this.emptyOrNull(this.state.insertTipusValue);
  //   submitObj.partnercsoportId = this.state.insertPartnercsoportValue;

  //   if (isCeg) {
  //     submitObj.cegnev = this.emptyOrNull(this.state.insertCegnevValue);
  //     submitObj.titulus = null;
  //     submitObj.vezeteknev = null;
  //     submitObj.keresztnev = null;
  //   } else {
  //     submitObj.cegnev = null;
  //     submitObj.titulus = this.emptyOrNull(this.state.insertTitulusValue);
  //     submitObj.vezeteknev = this.emptyOrNull(this.state.insertVezeteknevValue);
  //     submitObj.keresztnev = this.emptyOrNull(this.state.insertKeresztnevValue);
  //   }
  //   submitObj.telefontipus = this.emptyOrNull(this.state.insertTelefontipusValue);
  //   submitObj.orszaghivo = this.emptyOrNull(this.state.insertOrszaghivoValue);
  //   submitObj.telefon = this.emptyOrNull(this.state.insertTelefonValue);
  //   submitObj.email = this.emptyOrNull(this.state.insertEmailValue);

  //   Services.insertPartner(this.state.helyszinValue, submitObj, (err, res) => {
  //     if (!err) {
  //       let partner = {};
  //         partner.id = res[0].ptId;

  //       this.setState({
  //         savePartnerLoading: false,
  //         partnerResponse: res[0],
  //         showTulajdonosGdprForm: !isCeg,
  //         partnerValue: partner
  //       });
  //       if (isCeg) {
  //        this.togglePartnerModal();
  //        this.setPartnerAdatok();
  //       }
  //     } else {
  //       this.setState({ savePartnerLoading: false });
  //     }
  //   })
  // }

  insertPartner = () => {
    this.setState({ savePartnerLoading: true });
    if (!this.state.elfogadas && this.state.insertTipusValue == 'MAGANSZEMELY') {
      this.props.globals.addError('A partner csak a GDPR hozzájárulás elfogadását követően rögzíthető!');
      return;
    }

    let isCeg = 'CEG' === this.state.insertTipusValue;
    let submitObj = {};
    submitObj.tipus = this.emptyOrNull(this.state.insertTipusValue);
    submitObj.partnercsoportId = this.state.insertPartnercsoportValue;

    if (isCeg) {
      submitObj.cegnev = this.emptyOrNull(this.state.insertCegnevValue);
      submitObj.titulus = null;
      submitObj.vezeteknev = null;
      submitObj.keresztnev = null;
    } else {
      submitObj.cegnev = null;
      submitObj.titulus = this.emptyOrNull(this.state.insertTitulusValue);
      submitObj.vezeteknev = this.emptyOrNull(this.state.insertVezeteknevValue);
      submitObj.keresztnev = this.emptyOrNull(this.state.insertKeresztnevValue);
    }
    submitObj.telefontipus = this.emptyOrNull(this.state.insertTelefontipusValue);
    submitObj.orszaghivo = this.emptyOrNull(this.state.insertOrszaghivoValue);
    submitObj.telefon = this.emptyOrNull(this.state.insertTelefonValue);
    submitObj.email = this.emptyOrNull(this.state.insertEmailValue);

    Services.insertPartner(this.state.helyszinValue, submitObj, (err, res) => {
      if (!err) {
        let partner = {};
          partner.id = res[0].ptId;

        this.setState({
          savePartnerLoading: false,
          partnerResponse: res[0],
          // showTulajdonosGdprForm: !isCeg,
          partnerValue: partner
        });
        this.togglePartnerModal();
        this.setPartnerAdatok();
      } else {
        this.setState({ savePartnerLoading: false });
      }
    })
  }

  submitForm = () => {
    this.setState({
      saveButtonLoading: true
    });

    let submitObj = {};
    submitObj.teremid = this.state.teremValue && parseInt(this.state.teremValue, 10);
    submitObj.teremkiosztasid = this.state.kiosztasValue && parseInt(this.state.kiosztasValue, 10);
    submitObj.kezdeteidopont = this.dateToTimezone(this.state.kezdeteidopontValue);
    submitObj.vegeidopont = this.dateToTimezone(this.state.vegeidopontValue);
    submitObj.nev = this.emptyOrNull(this.state.programnevValue);
    submitObj.leiras = this.emptyOrNull(this.state.leirasValue);
    submitObj.letszam = NumberFormatter.removeSpacesFromString(this.state.letszamValue); 
    submitObj.partnertortenetid = this.state.partnerValue && this.state.partnerValue.id && parseInt(this.state.partnerValue.id, 10);

    if (this.props.hasFizKarbRole) {
      submitObj.dij = NumberFormatter.removeSpacesFromString(this.state.dijValue);
      submitObj.penznemid = this.state.penznemValue && parseInt(this.state.penznemValue, 10);
      submitObj.fizetesimodid = this.state.fizmodValue && parseInt(this.state.fizmodValue, 10);
      submitObj.fizetesidopont = this.dateToTimezone(this.state.fizetesidopontValue);
      submitObj.bizonylatszam = this.emptyOrNull(this.state.bizonylatszamValue);
    }

    if (this.props.formType === 'INSERT') {
      Services.addTeremberles(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Terembérlés sikeresen felvéve!');
          this.setState({
            saveButtonLoading: false,
            teremberlesObj: {},
          }, () => {
            this.props.toggleFormModal();
            this.props.listTeremberles();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    } else if (this.props.formType === 'MODIFY') {
      submitObj.id = this.props.id;

      Services.modifyTeremberles(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Termembérlés sikeresen módosítva!');
          this.setState({
            saveButtonLoading: false,
            teremberlesObj: {},
          }, () => {
            this.props.toggleFormModal();
            this.props.listTeremberles();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    }
  }

  render() {
    return (
      <Localization date={localizer}>
        <React.Fragment>
          <Modal isOpen={this.props.modalView} toggle={this.props.toggleViewModal} backdrop="static" size="md">
              <ModalHeader>Megtekintés</ModalHeader>
              <ModalBody>
                  {{
                    LOAD: (<Loader />),
                    NETW: (<NetworkEmptyState
                      hasImage
                      submitClick={() => {this.getTeremberles(this.props.id)}}
                    />),
                    DATA: (this.renderView())
                  }[this.state.formStatus]}
                </ModalBody>
              <ModalFooter>
                <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.props.toggleViewModal}>Bezárás</Button>
              </ModalFooter>
          </Modal>
          {/* <Modal isOpen={this.props.modalForm} toggle={this.props.toggleFormModal} backdrop="static" size="lg">
              <ModalHeader>{this.renderFormTitle()}</ModalHeader>
              <ModalBody style={ {paddingBottom: '0'} }> */}
                <RFForm
                  onSubmit={this.submitForm}
                  modalInsert
                  title={this.renderFormTitle()}
                  tagProps={{ isOpen: this.props.modalForm, toggle: this.props.toggleFormModal, backdrop: 'static', size:'lg' }}
                  footer={
                    <React.Fragment>
                      <ProgressButton
                        className="btn-cursor-pointer"
                        color="primary"
                        loading={this.state.saveButtonLoading}
                        onClick={this.submitForm}
                      >
                        {'Mentés'}
                      </ProgressButton>
                      <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={() => { this.props.toggleFormModal() }}>Mégsem</Button>
                    </React.Fragment>
                  }
                >
                  <div className="row">
                    {this.renderAlapadatok()}
                    {this.renderBerloAdatok()}
                    {this.props.hasFizKarbRole && this.renderFizetesiAdatok()}
                    {/* <ModalFooter style={ {width: '100%'} }>
                      <ProgressButton
                        className="btn-cursor-pointer"
                        color="primary"
                        loading={this.state.saveButtonLoading}
                      >
                        {'Mentés'}
                      </ProgressButton>
                      <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={() => { this.props.toggleFormModal() }}>Mégsem</Button>
                    </ModalFooter> */}
                  </div>
                </RFForm>
                <Modal isOpen={this.state.partnerModal} toggle={this.props.togglePartnerModal} backdrop="static" size="lg">
                  <RFForm
                    onSubmit={this.insertPartner}
                    modalInsert
                    title={'Partner rögzítése'}
                    tagProps={{ isOpen: this.state.partnerModal, toggle: this.props.togglePartnerModal, backdrop: 'static', size: 'lg' }}
                    footer={
                      <React.Fragment>
                        <Button
                          className="btn-cursor-pointer"
                          color="primary"
                          onClick={this.insertPartner}
                        >
                          {'Mentés'}
                        </Button>
                        <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.togglePartnerModal}>Mégsem</Button>
                      </React.Fragment>
                    }
                  >
                    {/* <ModalHeader>Partner rögzítése</ModalHeader> */}
                    {/* <ModalBody> */}
                      <div className="row">
                        {this.renderPartnerRogzites()}
                      </div>
                    {/* </ModalBody> */}
                    {/* <ModalFooter>
                      <ProgressButton
                        className="btn-cursor-pointer"
                        color="primary"
                        loading={this.state.savePartnerLoading}
                      >
                        {'Mentés'}
                      </ProgressButton>
                      <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.togglePartnerModal}>Mégsem</Button>
                    </ModalFooter> */}
                  </RFForm>
              </Modal>
              {/* {(this.state.showTulajdonosGdprForm && this.state.partnerResponse) && (
                <PartnerHozzajarulasForm
                  globals={this.props.globals}
                  partnerId={this.state.partnerResponse.pId}
                  hozzajarulasData={this.state.partnerResponse.hozzajarulasok}
                  hozzajarulasModal={this.state.showTulajdonosGdprForm}
                  toggleHozzajarulasModal={this.toggleShowTulajdonosGdprForm}
                  togglePartnerModal={this.togglePartnerModal}
                  setPartnerAdatok={this.setPartnerAdatok}
                  originalPartner={this.state.originalPartner}
                >
                </PartnerHozzajarulasForm>
              )} */}
              {/* </ModalBody> */}
          {/* </Modal> */}
          <Modal isOpen={this.props.modalDelete} toggle={this.props.toggleDeleteModal} backdrop="static" size="md">
            <ModalHeader>Törlés</ModalHeader>
            <ModalBody>
              <div className="delete-title-text" style={{ marginBottom: 12 }}>Valóban törölni kívánod a kiválasztott tételt?</div>
            </ModalBody>
            <ModalFooter>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                loading={this.state.deleteButtonLoading}
                onClick={() => this.deleteTeremberles(this.props.id)}
              >
                {'Igen'}
              </ProgressButton>
              <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.props.toggleDeleteModal}>Mégsem</Button>
            </ModalFooter>
          </Modal>
        </React.Fragment>
      </Localization>
    );
  }
}

export default TeremberlesUrlap;
